/** Random types not worthy of their own file */
export const misc = {
    'chemical/x-cdx': {
        extensions: ['cdx'],
        source: 'apache',
    },
    'chemical/x-cif': {
        extensions: ['cif'],
        source: 'apache',
    },
    'chemical/x-cmdf': {
        extensions: ['cmdf'],
        source: 'apache',
    },
    'chemical/x-cml': {
        extensions: ['cml'],
        source: 'apache',
    },
    'chemical/x-csml': {
        extensions: ['csml'],
        source: 'apache',
    },
    'chemical/x-xyz': {
        extensions: ['xyz'],
        source: 'apache',
    },
    'font/collection': {
        extensions: ['ttc'],
        source: 'iana',
    },
    'font/otf': {
        extensions: ['otf'],
        source: 'iana',
    },
    'font/ttf': {
        extensions: ['ttf'],
        source: 'iana',
    },
    'font/woff': {
        extensions: ['woff'],
        source: 'iana',
    },
    'font/woff2': {
        extensions: ['woff2'],
        source: 'iana',
    },
    'message/disposition-notification': {
        extensions: ['disposition-notification'],
        source: 'iana',
    },
    'message/global': {
        extensions: ['u8msg'],
        source: 'iana',
    },
    'message/global-delivery-status': {
        extensions: ['u8dsn'],
        source: 'iana',
    },
    'message/global-disposition-notification': {
        extensions: ['u8mdn'],
        source: 'iana',
    },
    'message/global-headers': {
        extensions: ['u8hdr'],
        source: 'iana',
    },
    'message/rfc822': {
        extensions: ['eml', 'mime'],
        source: 'iana',
    },
    'message/vnd.wfa.wsc': {
        extensions: ['wsc'],
        source: 'iana',
    },
    'model/3mf': {
        extensions: ['3mf'],
        source: 'iana',
    },
    'model/gltf+json': {
        extensions: ['gltf'],
        source: 'iana',
    },
    'model/gltf-binary': {
        extensions: ['glb'],
        source: 'iana',
    },
    'model/iges': {
        extensions: ['igs', 'iges'],
        source: 'iana',
    },
    'model/mesh': {
        extensions: ['msh', 'mesh', 'silo'],
        source: 'iana',
    },
    'model/mtl': {
        extensions: ['mtl'],
        source: 'iana',
    },
    'model/obj': {
        extensions: ['obj'],
        source: 'iana',
    },
    'model/step': {
        extensions: ['.p21', '.stp', '.step', '.stpnc', '.210'],
        source: 'iana',
    },
    'model/step+xml': {
        extensions: ['stpx'],
        source: 'iana',
    },
    'model/step+zip': {
        extensions: ['stpz'],
        source: 'iana',
    },
    'model/step-xml+zip': {
        extensions: ['stpxz'],
        source: 'iana',
    },
    'model/stl': {
        extensions: ['stl'],
        source: 'iana',
    },
    'model/vnd.collada+xml': {
        extensions: ['dae'],
        source: 'iana',
    },
    'model/vnd.dwf': {
        extensions: ['dwf'],
        source: 'iana',
    },
    'model/vnd.gdl': {
        extensions: ['gdl'],
        source: 'iana',
    },
    'model/vnd.gtw': {
        extensions: ['gtw'],
        source: 'iana',
    },
    'model/vnd.mts': {
        extensions: ['mts'],
        source: 'iana',
    },
    'model/vnd.opengex': {
        extensions: ['ogex'],
        source: 'iana',
    },
    'model/vnd.parasolid.transmit.binary': {
        extensions: ['x_b'],
        source: 'iana',
    },
    'model/vnd.parasolid.transmit.text': {
        extensions: ['x_t'],
        source: 'iana',
    },
    'model/vnd.sap.vds': {
        extensions: ['vds'],
        source: 'iana',
    },
    'model/vnd.usdz+zip': {
        extensions: ['usdz'],
        source: 'iana',
    },
    'model/vnd.valve.source.compiled-map': {
        extensions: ['bsp'],
        source: 'iana',
    },
    'model/vnd.vtu': {
        extensions: ['vtu'],
        source: 'iana',
    },
    'model/vrml': {
        extensions: ['wrl', 'vrml'],
        source: 'iana',
    },
    'model/x3d+binary': {
        extensions: ['x3db', 'x3dbz'],
        source: 'apache',
    },
    'model/x3d+fastinfoset': {
        extensions: ['x3db'],
        source: 'iana',
    },
    'model/x3d+vrml': {
        extensions: ['x3dv', 'x3dvz'],
        source: 'apache',
    },
    'model/x3d+xml': {
        extensions: ['x3d', 'x3dz'],
        source: 'iana',
    },
    'model/x3d-vrml': {
        extensions: ['x3dv'],
        source: 'iana',
    },
    'x-conference/x-cooltalk': {
        extensions: ['ice'],
        source: 'apache',
    },
} as const;
